import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import HeroItem from "./hero-item.component";

const options = {
  loop: true,
  items: 1,
  margin: 0,
  dots: "true",
  nav: "true",
  animateOut: "slideOutDown",
  animateIn: "fadeIn",
  active: "true",
  smartSpeed: 1500,
  autoplay: "false",
};

const HeroSlider = ({ slides }) => {
  return (
    <div className="home10-mainslider">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 p0">
            <div className="main-banner-wrapper home10">
              <OwlCarousel className="banner-style-one owl-theme" {...options}>
                {slides.map((slide, index) => (
                  <HeroItem key={index} slide={slide} />
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
